/**
 * UI elements
 */
class TJ_UI {
  constructor() {
    this.initSmoothScroll();
    this.detectEdge();
  }

  initSmoothScroll () {
    $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function(event) {
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
        &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
          event.preventDefault();
          $('html, body').animate({
            scrollTop: target.offset().top - 110
          }, 1000);
        }
      }
    });
  }

  detectEdge () {
    if (document.documentMode || /Edge/.test(navigator.userAgent)) {
      document.body.classList.add('browser--is-edge')
    }
  }
}
